module.exports = __webpack_public_path__ + "static/media/OMSmith.00772813.png";